export const PHONE_DIGITS_LENGTH = 10;

/** Strip formatting and +91 country code → bare 10-digit local number. */
export function barePhone(raw?: string): string {
  return (raw || '')
    .trim()
    .replace(/[\s\-()]/g, '')
    .replace(/^\+/, '')
    .replace(/^91(?=\d{10}$)/, '');
}

/** True when the value is exactly 10 numeric digits (after stripping +91). */
export function isValidPhoneNumber(raw?: string): boolean {
  return /^\d{10}$/.test(barePhone(raw));
}

export function validatePhoneNumber(
  raw?: string,
  options: { required?: boolean } = {},
): string | undefined {
  const { required = true } = options;
  const trimmed = (raw || '').trim();
  if (!trimmed) {
    return required ? 'Phone number is required' : undefined;
  }
  if (!isValidPhoneNumber(trimmed)) {
    return 'Enter a valid 10-digit phone number';
  }
  return undefined;
}

/** Restrict phone input to digits only, max 10 characters. */
export function formatPhoneInput(value: string): string {
  return value.replace(/^\+91/, '').replace(/\D/g, '').slice(0, PHONE_DIGITS_LENGTH);
}
